import Vue from 'vue'
import store from '@/store'

Vue.directive('permission', {
  inserted(el, binding) {
    const { value } = binding
    if (!value) return

    // 1. 工厂 ERP 权限：增删改按钮在 ERP 模式下隐藏
    const editButtons = ['button:add', 'button:edit', 'button:delete', 'button:import']
    if (editButtons.includes(value)) {
      // 从 localStorage 读取（切换工厂后刷新时最可靠），Vuex 作为补充
      const erpType = localStorage.getItem('erpType') || 'NONE'
      if (erpType !== 'NONE') {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }
      // NONE 模式下不做 ERP 限制，继续检查角色权限
    }

    // 2. 原有角色权限检查
    const hasPerm = store.getters.hasPermission(value)
    if (!hasPerm) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})
